<!-- 变种选择，支持label标签选择或select下拉选择 -->
<template>
  <div class="variant-select" :class="`variant-select--${showType}`">
    <template v-if="showType === 'label'">
      <label
        class="variant-select__label"
        v-for="item in attrs"
        :key="item"
        :class="{
          selected: value === item,
        }"
      >
        <span @click="() => handleClick(item)">
          {{ item }}
        </span>
      </label>
    </template>
    <template v-else>
      <el-select class="variant-select__select" :value="value" @change="handleChange">
        <el-option v-for="item in attrs" :key="item" :value="item"
          :label="name ? `${name}: ${value}` : value"
        >
          {{ item }}
        </el-option>
      </el-select>
    </template>
  </div>
</template>

<script>
export default {
  name: 'VarinatSelect',
  model: {
    value: 'value',
    event: 'change',
  },
  props: {
    // 双向绑定的值
    value: {
      type: String,
      default: null,
    },
    //
    attrs: {
      type: Array,
      default: [],
    },
    showType: {
      type: String,
      default: 'label',
      validator(value) {
        // 这个值必须匹配下列字符串中的一个
        return ['label', 'select'].includes(value)
      },
    },
    name: {
      type: String,
      default: null,
    },
  },
  data() {
    return {}
  },
  methods: {
    // 点击选择
    handleClick(val) {
      if (val === this.value) return
      this.$emit('change', val)
    },
    // select 选择
    handleChange(value) {
      console.log(value)
      this.$emit('change', value)
    },
  },
}
</script>

<style lang="scss" scoped>
.variant-select {
  &--label {
    margin-left: -6px;
    margin-right: -6px;
  }
  &__label {
    display: inline-block;
    padding: 6px 6px;
    margin: 0;
    span {
      display: inline-block;
      height: 44px;
      line-height: 44px;
      padding: 0px 11px;
      font-size: 12px;
      display: inline-block;
      cursor: pointer;
      border: 1px solid #d2d2d2;
      color: #222323;
    }
    &.selected {
      span {
        background-color: var(--main-btn-bg);
        border-color: var(--main-btn-bg);
        color: var(--main-btn-tx);
      }
    }
  }
  &__select {
    width: 100%;
    ::v-deep {
      .el-input {
        &__inner {
          height: 46px;
          line-height: 46px;
          border: 1px solid #ccc;
          color: #333;
          padding-left: 10px;
          border-radius: 0;
        }
      }
    }
  }
}
</style>